import { LEGACY_GAME_MODES_MAP } from '../../consts';

export default {
	getGameMode: () => ({ legacyMode }) => {
		return LEGACY_GAME_MODES_MAP[legacyMode];
	}
};
